import { createHazardScoreBadge } from '../ScoreBadge'

export const freezeThawScoreLabels: Record<number, string> = {
  1: 'Low',
  2: 'Moderate',
  3: 'Moderate to High',
  4: 'High',
  5: 'Very High',
}

export const freezeThawScoreColors: Record<number, string> = {
  1: '#c6e8be',
  2: '#f7e4af',
  3: '#f6c8a4',
  4: '#f3a5a5',
  5: '#e8747d',
}

export const FreezeThawScoreBadge = createHazardScoreBadge({
  labels: freezeThawScoreLabels,
  palette: freezeThawScoreColors,
})
